export default __webpack_public_path__ + "static/media/link_pic.5bbed02c.png";